// SPDX-License-Identifier: AGPL-3.0-or-later

import {CopyRoleIdMenuItem} from '@app/features/ui/action_menu/items/CopyMenuItems';
import {MenuGroup} from '@app/features/ui/action_menu/MenuGroup';
import * as ContextMenuCommands from '@app/features/ui/commands/ContextMenuCommands';
import type React from 'react';

interface RoleContextMenuProps {
	roleId: string;
	onClose: () => void;
}
export const RoleContextMenu: React.FC<RoleContextMenuProps> = ({roleId, onClose}) => {
	return (
		<MenuGroup>
			<CopyRoleIdMenuItem roleId={roleId} onClose={onClose} />
		</MenuGroup>
	);
};
export function openRoleContextMenu(event: React.MouseEvent | MouseEvent, roleId: string): void {
	ContextMenuCommands.openFromEvent(event, ({onClose}) => <RoleContextMenu roleId={roleId} onClose={onClose} />);
}
